var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._v(
      "\n    " +
        _vm._s(
          _vm.$t("notification.driveFolderRenamed", {
            actor: _vm.$_.get(_vm.activity, "actorUser.name"),
            oldName: _vm.$_.get(_vm.activity, "payload.oldName"),
            newName: _vm.$_.get(_vm.activity, "payload.newName"),
          })
        ) +
        "\n"
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }